import { RootState } from '../rootState'
import { CmsPageState, initialCmsPageState } from '../cmsPage/cmsPageState'
import { initialNewsOverviewState, NewsOverviewState } from '../newsOverview/newsOverviewState'
import { initialSearchPageState, SearchPageState } from '../searchPage/searchPageState'
import { initialSpecialistOverviewState, SpecialistOverviewState } from '../specialistOverview/specialistOverviewState'
import {
  DepartmentOrCentrumOverviewState,
  initialDepartmentOrCentrumOverviewState,
} from '../departmentsAndCentraOverview/departmentsAndCentraOverviewState'
import {
  VerpleegafdelingenOverviewState,
  initialVerpleegafdelingenOverviewState,
} from '../verpleegafdelingenOverview/verpleegafdelingenOverviewState'
import {
  getEventPage,
  getSpaarnePage,
  getHomePage,
  getNewsPage,
  getLocationOrSpaarnePage,
  getSpecialistPage,
  getWaitingTimesPage,
  getSubDepartmentOrDepartmentOrSubcentrumOrSpaarne,
  getResearchPage,
  getSubDepartmentOrSpaarnePage,
  getDepartmentOrCentrumPage,
  getPreview,
  getFriendPage,
  getFolderPage,
  getDossierPage,
  getDossierChildPage,
} from '../cmsPage/sharepointPageApi/sharepointPageApi'
import { EventOverviewState, initialEventOverviewState } from '../eventOverview/eventOverviewState'
import { initialNotFoundState, NotFoundState } from '../notFound/notFoundState'
import {
  initialNewsAndEventsOverviewState,
  NewsAndEventsOverviewState,
} from '../newsAndEventsOverview/newsAndEventsOverviewState'
import { FoldersState, initialFoldersState } from '../folders/foldersState'
import { initialResearchOverviewState, ResearchOverviewState } from '../researchOverview/researchOverviewState'
import { RouteBuilders, RouteUpdaters } from '../../utils/routes.shared'

type SlugParam = { slug: string }
type PageParam = { page?: string }
type DepartmentorCentrumFilterParam = { afdelingOfCentrum?: string }
type FoldersSearchParam = { zoek?: string }
type DepartmentParam = { department?: string }
type SubdepartmentParam = { subDepartment?: string }
type CentrumParam = { centrum?: string }
type SubcentrumParam = { subcentrum?: string }
type SpecialistParam = { specialist?: string }
type TagsParam = { tags?: string }

export const pageParamToPage = (page?: string) => {
  const pageParamInt = page ? parseInt(page) : NaN
  return isNaN(pageParamInt) ? 1 : pageParamInt
}

export type Pages = {
  redirect: {
    url: [{ to: string }]
    to: string
  }
  notFound: {
    url: []
    pageState: NotFoundState
  }

  home: {
    url: []
    pageState: CmsPageState
  }

  englishHome: {
    url: []
    pageState: CmsPageState
  }

  spaarnePrimary: {
    url: [SlugParam]
    pageState: CmsPageState
  }

  spaarneSecondary: {
    url: [{ parentSlug: string }, SlugParam]
    pageState: CmsPageState
  }

  spaarneTernary: {
    url: [{ grandParentSlug: string }, { parentSlug: string }, SlugParam]
    pageState: CmsPageState
  }

  englishSpaarnePrimary: {
    url: [SlugParam]
    pageState: CmsPageState
  }

  englishSpaarneSecondary: {
    url: [{ parentSlug: string }, SlugParam]
    pageState: CmsPageState
  }

  englishSpaarneTernary: {
    url: [{ grandParentSlug: string }, { parentSlug: string }, SlugParam]
    pageState: CmsPageState
  }

  newsAndEventsOverview: {
    url: [PageParam, TagsParam, SpecialistParam, DepartmentParam, SubdepartmentParam, CentrumParam, SubcentrumParam]
    pageState: NewsAndEventsOverviewState
  }

  departmentsAndCentraOverview: {
    url: [PageParam]
    pageState: DepartmentOrCentrumOverviewState
  }

  verpleegafdelingenOverview: {
    url: [PageParam, { location: string }]
    pageState: VerpleegafdelingenOverviewState
  }

  friendHome: {
    url: [PageParam, SlugParam]
    pageState: CmsPageState
  }

  friend: {
    url: [PageParam, SlugParam]
    pageState: CmsPageState
  }

  departmentOrCentrum: {
    url: [SlugParam]
    pageState: CmsPageState
  }

  subDepartmentOrDepartmentOrSubCentrumOrSpaarne: {
    url: [{ departmentOrCentrumSlug: string }, SlugParam]
    pageState: CmsPageState
  }

  subDepartmentOrSpaarne: {
    url: [{ centrumSlug: string }, { departmentOrSpaarneSlug?: string }, SlugParam]
    pageState: CmsPageState
  }

  eventOverview: {
    url: [PageParam, TagsParam, SpecialistParam, DepartmentParam, SubdepartmentParam, CentrumParam, SubcentrumParam]
    pageState: EventOverviewState
  }

  event: {
    url: [SlugParam]
    pageState: CmsPageState
  }

  newsOverview: {
    url: [PageParam, TagsParam, SpecialistParam, DepartmentParam, SubdepartmentParam, CentrumParam, SubcentrumParam]
    pageState: NewsOverviewState
  }

  dossierPage: {
    url: [SlugParam]
    pageState: CmsPageState
  }

  dossierChildPage: {
    url: [{ dossierSlug: string }, SlugParam]
    pageState: CmsPageState
  }

  news: {
    url: [SlugParam]
    pageState: CmsPageState
  }

  locationOrSpaarne: {
    url: [SlugParam]
    pageState: CmsPageState
  }

  specialistOverview: {
    url: [PageParam, { filter?: string }, { filter2?: string }, { search?: string }]
    pageState: SpecialistOverviewState
  }

  specialist: {
    url: [SlugParam]
    pageState: CmsPageState
  }

  search: {
    url: [PageParam, { query?: string }]
    pageState: SearchPageState
  }

  englishSearch: {
    url: [PageParam, { query?: string }]
    pageState: SearchPageState
  }

  folders: {
    url: [
      DepartmentorCentrumFilterParam,
      FoldersSearchParam,
      DepartmentParam,
      SubdepartmentParam,
      CentrumParam,
      SubcentrumParam
    ]
    pageState: FoldersState
  }

  waitingTimes: {
    url: [DepartmentParam, CentrumParam]
    pageState: CmsPageState
  }

  researchOverview: {
    url: [PageParam, { filter?: string }, { filter2?: string }, { search?: string }, { search2?: string }]
    pageState: ResearchOverviewState
  }

  research: {
    url: [SlugParam]
    pageState: CmsPageState
  }

  folderPage: {
    url: [SlugParam]
    pageState: CmsPageState
  }

  preview: {
    url: [SlugParam, { token: string }]
    pageState: CmsPageState
  }
}

export const routeBuilders: RouteBuilders<RootState, Pages> = {
  redirect: {
    make: (params) => ({
      kind: 'redirect',
      params,
      to: params.to,
    }),
  },
  notFound: {
    make: (params) => ({
      kind: 'notFound',
      params: params,
      pageState: initialNotFoundState,
    }),
  },
  home: {
    make: (params) => ({
      kind: 'home',
      params: params,
      pageState: initialCmsPageState(() => getHomePage('nl')),
    }),
  },
  englishHome: {
    make: (params) => ({
      kind: 'englishHome',
      params: params,
      pageState: initialCmsPageState(() => getHomePage('en')),
    }),
  },
  spaarnePrimary: {
    make: (params) => ({
      kind: 'spaarnePrimary',
      params: params,
      pageState: initialCmsPageState(() => getSpaarnePage('nl', undefined, undefined, params.slug)),
    }),
  },
  spaarneSecondary: {
    make: (params) => ({
      kind: 'spaarneSecondary',
      params: params,
      pageState: initialCmsPageState(() => getSpaarnePage('nl', undefined, params.parentSlug, params.slug)),
    }),
  },
  spaarneTernary: {
    make: (params) => ({
      kind: 'spaarneTernary',
      params: params,
      pageState: initialCmsPageState(() =>
        getSpaarnePage('nl', params.grandParentSlug, params.parentSlug, params.slug)
      ),
    }),
  },
  englishSpaarnePrimary: {
    make: (params) => ({
      kind: 'englishSpaarnePrimary',
      params: params,
      pageState: initialCmsPageState(() => getSpaarnePage('en', undefined, undefined, params.slug)),
    }),
  },
  englishSpaarneSecondary: {
    make: (params) => ({
      kind: 'englishSpaarneSecondary',
      params: params,
      pageState: initialCmsPageState(() => getSpaarnePage('en', undefined, params.parentSlug, params.slug)),
    }),
  },
  englishSpaarneTernary: {
    make: (params) => ({
      kind: 'englishSpaarneTernary',
      params: params,
      pageState: initialCmsPageState(() =>
        getSpaarnePage('en', params.grandParentSlug, params.parentSlug, params.slug)
      ),
    }),
  },
  newsAndEventsOverview: {
    make: (params) => ({
      kind: 'newsAndEventsOverview',
      params: params,
      pageState: initialNewsAndEventsOverviewState(
        pageParamToPage(params.page),
        params.tags?.split(','),
        params.department,
        params.subDepartment,
        params.specialist,
        params.centrum,
        params.subcentrum
      ),
    }),
  },
  departmentsAndCentraOverview: {
    make: (params) => ({
      kind: 'departmentsAndCentraOverview',
      params: params,
      pageState: initialDepartmentOrCentrumOverviewState,
    }),
  },
  friend: {
    make: (params) => ({
      kind: 'friend',
      params: params,
      pageState: initialCmsPageState(() => getFriendPage(params.slug)),
    }),
  },
  friendHome: {
    make: (params) => ({
      kind: 'friendHome',
      params: params,
      pageState: initialCmsPageState(() => getFriendPage('')),
    }),
  },
  verpleegafdelingenOverview: {
    make: (params) => ({
      kind: 'verpleegafdelingenOverview',
      params: params,
      pageState: initialVerpleegafdelingenOverviewState(params.location),
    }),
  },
  departmentOrCentrum: {
    make: (params) => ({
      kind: 'departmentOrCentrum',
      params: params,
      pageState: initialCmsPageState(() => getDepartmentOrCentrumPage(params.slug)),
    }),
  },
  subDepartmentOrDepartmentOrSubCentrumOrSpaarne: {
    make: (params) => ({
      kind: 'subDepartmentOrDepartmentOrSubCentrumOrSpaarne',
      params: params,
      pageState: initialCmsPageState(() =>
        getSubDepartmentOrDepartmentOrSubcentrumOrSpaarne(params.departmentOrCentrumSlug, params.slug)
      ),
    }),
  },
  subDepartmentOrSpaarne: {
    make: (params) => ({
      kind: 'subDepartmentOrSpaarne',
      params: params,
      pageState: initialCmsPageState(() =>
        getSubDepartmentOrSpaarnePage(
          params.slug,
          params.departmentOrSpaarneSlug ? params.departmentOrSpaarneSlug : '',
          params.centrumSlug
        )
      ),
    }),
  },
  eventOverview: {
    make: (params) => ({
      kind: 'eventOverview',
      params: params,
      pageState: initialEventOverviewState(
        pageParamToPage(params.page),
        params.tags?.split(','),
        params.department,
        params.subDepartment,
        params.specialist,
        params.centrum,
        params.subcentrum
      ),
    }),
  },
  event: {
    make: (params) => ({
      kind: 'event',
      params: params,
      pageState: initialCmsPageState(() => getEventPage(params.slug)),
    }),
  },
  newsOverview: {
    make: (params) => ({
      kind: 'newsOverview',
      params: params,
      pageState: initialNewsOverviewState(
        pageParamToPage(params.page),
        params.tags?.split(','),
        params.department,
        params.subDepartment,
        params.specialist,
        params.centrum,
        params.subcentrum
      ),
    }),
  },
  dossierPage: {
    make: (params) => ({
      kind: 'dossierPage',
      params: params,
      pageState: initialCmsPageState(() => getDossierPage(params.slug)),
    }),
  },
  dossierChildPage: {
    make: (params) => ({
      kind: 'dossierChildPage',
      params: params,
      pageState: initialCmsPageState(() => getDossierChildPage(params.dossierSlug, params.slug)),
    }),
  },
  news: {
    make: (params) => ({
      kind: 'news',
      params: params,
      pageState: initialCmsPageState(() => getNewsPage(params.slug)),
    }),
  },
  locationOrSpaarne: {
    make: (params) => ({
      kind: 'locationOrSpaarne',
      params: params,
      pageState: initialCmsPageState(() => getLocationOrSpaarnePage(params.slug)),
    }),
  },
  specialistOverview: {
    make: (params) => ({
      kind: 'specialistOverview',
      params: params,
      pageState: initialSpecialistOverviewState(params.filter, params.filter2, params.search),
    }),
  },
  specialist: {
    make: (params) => ({
      kind: 'specialist',
      params: params,
      pageState: initialCmsPageState(() => getSpecialistPage(params.slug)),
    }),
  },
  search: {
    make: (params) => ({
      kind: 'search',
      params: params,
      pageState: initialSearchPageState(pageParamToPage(params.page), params.query || '', 'nl'),
    }),
  },
  englishSearch: {
    make: (params) => ({
      kind: 'englishSearch',
      params: params,
      pageState: initialSearchPageState(pageParamToPage(params.page), params.query || '', 'en'),
    }),
  },
  folders: {
    make: (params) => {
      const afdelingOfCentrum = params.afdelingOfCentrum
        ? params.afdelingOfCentrum
        : params.department
        ? params.department
        : params.subDepartment
        ? params.subDepartment
        : params.centrum
        ? params.centrum
        : params.subcentrum
        ? params.subDepartment
        : undefined

      return {
        kind: 'folders',
        params: params,
        pageState: initialFoldersState(afdelingOfCentrum, params.zoek),
      }
    },
  },
  researchOverview: {
    make: (params) => ({
      kind: 'researchOverview',
      params: params,
      pageState: initialResearchOverviewState(params.filter, params.filter2, params.search, params.search2),
    }),
  },
  waitingTimes: {
    make: (params) => ({
      kind: 'waitingTimes',
      params: params,
      pageState: initialCmsPageState(() => getWaitingTimesPage(params.department, params.centrum)),
    }),
  },
  research: {
    make: (params) => ({
      kind: 'research',
      params: params,
      pageState: initialCmsPageState(() => getResearchPage(params.slug)),
    }),
  },
  folderPage: {
    make: (params) => ({
      kind: 'folderPage',
      params: params,
      pageState: initialCmsPageState(() => getFolderPage(params.slug)),
    }),
  },
  preview: {
    make: (params) => ({
      kind: 'preview',
      params: params,
      pageState: initialCmsPageState(() => getPreview(params.slug, params.token)),
    }),
  },
}

export const routeUpdaters: RouteUpdaters<RootState, Pages> = {
  redirect: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.redirect.make(params),
      }),
    url: '', // Not used,
  },
  notFound: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.notFound.make(params),
      }),
    url: '',
  },
  home: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.home.make(params),
      }),
    url: '/',
  },
  englishHome: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.englishHome.make(params),
      }),
    url: '/en',
  },
  spaarnePrimary: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.spaarnePrimary.make(params),
      }),
    url: '/:slug',
  },
  spaarneSecondary: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.spaarneSecondary.make(params),
      }),
    url: '/:parentSlug/:slug',
  },
  spaarneTernary: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.spaarneTernary.make(params),
      }),
    url: '/:grandParentSlug/:parentSlug/:slug',
  },
  englishSpaarnePrimary: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.englishSpaarnePrimary.make(params),
      }),
    url: '/en/:slug',
  },
  englishSpaarneSecondary: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.englishSpaarneSecondary.make(params),
      }),
    url: '/en/:parentSlug/:slug',
  },
  englishSpaarneTernary: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.englishSpaarneTernary.make(params),
      }),
    url: '/en/:grandParentSlug/:parentSlug/:slug',
  },
  eventOverview: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.eventOverview.make(params),
      }),
    url: '/agenda',
  },
  newsAndEventsOverview: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.newsAndEventsOverview.make(params),
      }),
    url: '/nieuws-en-agenda',
  },
  departmentsAndCentraOverview: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.departmentsAndCentraOverview.make(params),
      }),
    url: '/afdelingen-en-centra',
  },
  verpleegafdelingenOverview: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.verpleegafdelingenOverview.make(params),
      }),
    url: '/verpleegafdelingen',
  },
  friend: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.friend.make(params),
      }),
    url: '/vrienden/:slug',
  },
  friendHome: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.friendHome.make(params),
      }),
    url: '/vrienden',
  },
  departmentOrCentrum: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.departmentOrCentrum.make(params),
      }),
    url: '/afdelingen-en-centra/:slug',
  },
  subDepartmentOrDepartmentOrSubCentrumOrSpaarne: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.subDepartmentOrDepartmentOrSubCentrumOrSpaarne.make(params),
      }),
    url: '/afdelingen-en-centra/:departmentOrCentrumSlug/:slug',
  },
  subDepartmentOrSpaarne: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.subDepartmentOrSpaarne.make(params),
      }),
    url: '/afdelingen-en-centra/:centrumSlug/:departmentOrSpaarneSlug/:slug',
  },
  event: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.event.make(params),
      }),
    url: '/agenda/:slug',
  },
  newsOverview: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.newsOverview.make(params),
      }),
    url: '/nieuws',
  },
  dossierPage: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.dossierPage.make(params),
      }),
    url: '/dossiers/:slug',
  },
  dossierChildPage: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.dossierChildPage.make(params),
      }),
    url: '/dossiers/:dossierSlug/:slug',
  },
  news: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.news.make(params),
      }),
    url: '/nieuws/:slug',
  },
  locationOrSpaarne: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.locationOrSpaarne.make(params),
      }),
    url: '/contact/:slug',
  },
  specialistOverview: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.specialistOverview.make(params),
      }),
    url: '/specialisten',
  },
  specialist: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.specialist.make(params),
      }),
    url: '/specialisten/:slug',
  },
  search: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.search.make(params),
      }),
    url: '/zoeken',
  },
  englishSearch: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.englishSearch.make(params),
      }),
    url: '/en/search',
  },
  folders: {
    jumpTo: (params) => {
      const newPage = routeBuilders.folders.make(params)
      return (s0: RootState): RootState => {
        return {
          ...s0,
          page:
            s0.page.kind === 'folders' &&
            (s0.page.params.afdelingOfCentrum !== params.afdelingOfCentrum || s0.page.params.zoek !== params.zoek)
              ? {
                  ...newPage,
                  pageState: initialFoldersState(params.afdelingOfCentrum, params.zoek, s0.page.pageState),
                }
              : newPage,
        }
      }
    },
    url: '/folders',
  },

  waitingTimes: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.waitingTimes.make(params),
      }),
    url: '/wachttijden',
  },

  researchOverview: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.researchOverview.make(params),
      }),
    url: '/wetenschappelijke-onderzoeken',
  },

  research: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.research.make(params),
      }),
    url: '/wetenschappelijke-onderzoeken/:slug',
  },

  folderPage: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.folderPage.make(params),
      }),
    url: '/folders/:slug',
  },

  preview: {
    jumpTo:
      (params) =>
      (s0: RootState): RootState => ({
        ...s0,
        page: routeBuilders.preview.make(params),
      }),
    url: '/preview/:slug',
  },
}
